export default __webpack_public_path__ + "static/media/game_logo.0f41e784.png";